import type { GetBannersParams } from '../__generated__/gateway/gatewayApiTypes';

import { GatewayClient } from './client/GatewayClient';

export const getBanners = async (params: GetBannersParams) => {
  const { data } = await GatewayClient.get('/v1/advertising/banners', { params });

  return data;
};
